<template>
  <div>
    <div class="columns">
      <div class="column">
        <h1 class="title">Dokumentliste</h1>
        <h2 class="subtitle">Hier finden Sie alle hochgeladenen Dokumente</h2>
      </div>
      <div class="column">
        <div class="is-pulled-right">
          <b-button
            icon-right="upload"
            tag="router-link"
            :to="{ name: 'DocumentUpload' }"
            type="is-primary"
            outlined
            >Dokument hochladen</b-button
          >
        </div>
      </div>
    </div>
    <br />
    <DocumentTable :documents="documents">
      <template v-slot:default="slotProps">
        <router-link
          :to="{
            name: 'DocumentDetail',
            params: { docName: slotProps.docName }
          }"
          >{{ slotProps.docName }}</router-link
        >
      </template>
    </DocumentTable>
  </div>
</template>

<script>
import { ApiClient } from "@/api";
import DocumentTable from "@/components/DocumentTable";

export default {
  components: { DocumentTable },
  data() {
    return {
      documents: null
    };
  },
  methods: {
    listDocuments() {
      const DocumentService = new ApiClient("documents");
      DocumentService.get().then(response => (this.documents = response.data));
    }
  },
  mounted() {
    this.listDocuments();
  }
};
</script>

<style scoped lang="scss"></style>
